module.exports = __webpack_public_path__ + "img/P2-A1.a2f644ab.svg";